import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import { Typography, Box, Stack, CardMedia } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { demoChannelTitle, demoProfilePicture } from "../utils/constants.js";
import { MuiVideos } from "./";
import { fetchFromApi } from "../utils/fetchFromApi.js";
const MuiVideo = () => {
  const [videoDetails, setvideoDetails] = useState(null);
  const [videos, setvideos] = useState([]);
  const { videoId } = useParams();

  useEffect(() => {
    fetchFromApi(`videos?part=snippet,statistics&id=${videoId}`).then((data) =>
      setvideoDetails(data.items[0])
    );
    fetchFromApi(
      `search?part=snippet&relatedToVideoId=${videoId}&type=video`
    ).then((data) => setvideos(data.items));
  }, [videoId]);

  // if (!videoDetails?.sinppet) return "Loading ...";
  // const {
  //   sinppet: { title, channelTitle, publishTime },
  //   statistics: { viewCount, likeCount },
  // } = videoDetails;

  return (
    <Box minHeight="95vh">
      <Stack direction='column'>

          <Box sx={{ width: "100%", position: "sticky"}}>
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${videoId}`}
              className="react-player"
              playing={true}
              controls
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: "#FFF", mt: "15px" }}
            >
              {videoDetails?.snippet?.title}
            </Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ color: "#FFF" }}
              py={1}
              px={2}
            >
              <Link to={`/channel/${videoDetails?.snippet?.channelId}`}>
                <Stack direction="row" alignItems="center" gap={2}>
                  <CardMedia
                    image={
                      videoDetails?.snippet?.thumbnails?.high?.url ||
                      demoProfilePicture
                    }
                    alt={
                      videoDetails?.snippet?.channelTitle || demoChannelTitle
                    }
                    sx={{
                      borderRadius: "50%",
                      height: "30px",
                      width: "30px",
                      border: "1px solid #e3e3e3",
                    }}
                  />
                  <Typography
                    variant={{ sm: "subtitle1", md: "h6" }}
                    fontWeight="bold"
                    color="gray"
                  >
                    {videoDetails?.snippet?.channelTitle || demoChannelTitle}
                    <CheckCircleIcon
                      sx={{ fontSize: "17px", color: "gray", ml: "10px" }}
                    />
                  </Typography>
                </Stack>
              </Link>

              <Stack direction="row" alignItems="center" gap={2}>
                <Typography
                  variant={{ sm: "subtitle1", md: "h6" }}
                  fontWeight="bold"
                  color="gray"
                >
                  {parseInt(
                    videoDetails?.statistics?.viewCount
                  ).toLocaleString()}
                  Views
                </Typography>
                <Typography
                  variant={{ sm: "subtitle1", md: "h6" }}
                  fontWeight="bold"
                  color="gray"
                >
                  {parseInt(
                    videoDetails?.statistics?.likeCount
                  ).toLocaleString()}
                  Likes
                </Typography>
              </Stack>
            </Stack>
          </Box>

        <Box
          px={2}
          py={{ xs: 5, md: 1 }}
          justifyContent="center"
          alignItems="center"
        >
          <MuiVideos videos={videos} />
        </Box>
      </Stack>
    </Box>
  );
};

export default MuiVideo;
